import { render, staticRenderFns } from "./televiseLive.vue?vue&type=template&id=fa0505c4&scoped=true&"
import script from "./televiseLive.vue?vue&type=script&lang=js&"
export * from "./televiseLive.vue?vue&type=script&lang=js&"
import style0 from "./televiseLive.vue?vue&type=style&index=0&id=fa0505c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0505c4",
  null
  
)

export default component.exports